import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCog, faHourglassHalf, faRetweet } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton, BButtonGroup, BCollapse, BFormCheckbox } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { useNotificationsStore } from "@/stores/notificationsStore";
import Heading from "@/components/Common/Heading.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
import NotificationCard from "@/components/Notifications/NotificationCard.vue";
import NotificationsPreferences from "@/components/User/Notifications/NotificationsPreferences.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationsList',
    props: {
        shouldOpenPreferences: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        library.add(faCog, faHourglassHalf, faRetweet);
        const notificationsStore = useNotificationsStore();
        const { notifications, loadingNotifications } = storeToRefs(notificationsStore);
        const showUnread = ref(false);
        const showShared = ref(false);
        const preferencesOpen = ref(props.shouldOpenPreferences);
        const selectedNotificationIds = ref([]);
        const haveSelected = computed(() => selectedNotificationIds.value.length > 0);
        const filteredNotifications = computed(() => {
            return notifications.value.filter(filterNotifications);
        });
        const allSelected = computed(() => haveSelected.value && selectedNotificationIds.value.length === notifications.value.length);
        function filterNotifications(notification) {
            if (showUnread.value && showShared.value) {
                return !notification.seen_time && notification.category === "new_shared_item";
            }
            else if (showUnread.value) {
                return !notification.seen_time;
            }
            else if (showShared.value) {
                return notification.category === "new_shared_item";
            }
            else {
                return true;
            }
        }
        async function updateNotifications(changes) {
            await notificationsStore.updateBatchNotification({ notification_ids: selectedNotificationIds.value, changes });
            selectedNotificationIds.value = [];
        }
        function selectOrDeselectNotification(items) {
            const ids = items.map((item) => item.id);
            const selectedIds = selectedNotificationIds.value;
            const newSelectedIds = selectedIds.filter((id) => !ids.includes(id));
            if (newSelectedIds.length === selectedIds.length) {
                selectedNotificationIds.value = [...selectedIds, ...ids];
            }
            else {
                selectedNotificationIds.value = newSelectedIds;
            }
        }
        function togglePreferences() {
            preferencesOpen.value = !preferencesOpen.value;
        }
        return { __sfc: true, notificationsStore, notifications, loadingNotifications, props, showUnread, showShared, preferencesOpen, selectedNotificationIds, haveSelected, filteredNotifications, allSelected, filterNotifications, updateNotifications, selectOrDeselectNotification, togglePreferences, faCog, FontAwesomeIcon, BAlert, BButton, BButtonGroup, BCollapse, BFormCheckbox, Heading, LoadingSpan, NotificationCard, NotificationsPreferences };
    }
});
